import { StaticProvider } from '@angular/core';
import { Y42FeatureType } from '@y42/json-schema';

export abstract class FeatureProvidersServiceInterface {
  abstract prepareProviders(featureType: Y42FeatureType): StaticProvider[];
}
